import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dateFilter from './filters/formatDate';
import initAxiosInterceptors from './axios';

Vue.config.productionTip = false;

dateFilter.init();

initAxiosInterceptors();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
